import {useDispatch} from 'react-redux'
import {showAlert} from '../../redux/reducers/alertSlice'
import api from '../../../_metronic/helpers/api'
import {useNavigate} from 'react-router-dom'

export default function useUtils() {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const fetchSettings = async () => {
    try {
      const response = await api.get(`/setting`)
      if (response.data.status) {
        return response.data.data
      }
    } catch (error) {
      console.error('Error fetching settings:', error)
      return null
    }
  }

  const modifySettings = async (id, data) => {
    try {
      // Validate ID
      if (!id) {
        console.error('Setting ID is missing')
        dispatch(
          showAlert({
            message: 'Setting ID is missing',
            variant: 'danger',
          })
        )
        return false
      }
      const response = await api.patch(`/setting/${id}`, data)

      if (response.data.status === 'success') {
        dispatch(
          showAlert({
            message: `Setting Updated`,
            variant: 'success',
            timeout: '2000',
          })
        )
        return true
      } else {
        dispatch(
          showAlert({
            message: response.data.message || 'Failed to update settings',
            variant: 'warning',
          })
        )
        return false
      }
    } catch (error) {
      dispatch(
        showAlert({
          message: error?.response?.data?.message,
          variant: 'danger',
        })
      )
      return false
    }
  }

  const modifyBenefits = async (id, data) => {
    try {
      const response = await api.patch(`/benefit/${id}`, data)
      if (response.data.status) {
        dispatch(
          showAlert({
            message: `Success`,
            variant: 'success',
            timeout: '2000',
          })
        )
      }
    } catch (error) {
      dispatch(
        showAlert({
          message: error?.response?.data?.message,
          variant: 'danger',
        })
      )
    }
  }

  const fetchBenefits = async () => {
    try {
      const response = await api.get(`/benefit`)
      if (response.data.status) {
        return response.data.data
      }
    } catch (error) {
      console.error(error?.message)
    }
  }

  const fetchBenefit = async (id) => {
    try {
      const response = await api.get(`/benefit/${id}`)
      if (response.data.status) {
        return response.data.data
      }
    } catch (error) {
      console.error(error?.message)
    }
  }

  const addBenefit = async (data) => {
    try {
      const response = await api.post(`/benefit`, data)
      if (response.data.status) {
        return response.data.data
      }
    } catch (error) {
      console.error(error?.message)
    }
  }

  const editBenefit = async (id, data) => {
    try {
      const response = await api.patch(`/benefit/${id}`, data)
      if (response.data.status) {
        return response.data.data
      }
    } catch (error) {
      console.error(error?.message)
    }
  }

  const deleteBenefit = async (id) => {
    try {
      const response = await api.delete(`/benefit/${id}`)
      if (response.data.status) {
        dispatch(
          showAlert({
            message: 'Successfully Deleted',
            variant: 'success',
          })
        )
      }
    } catch (error) {
      console.error(error?.message)
    }
  }

  return {
    fetchSettings,
    addBenefit,
    deleteBenefit,
    modifySettings,
    fetchBenefits,
    modifyBenefits,
    deleteBenefit,
    fetchBenefit,
    editBenefit,
  }
}
